module.exports = __webpack_public_path__ + "static/media/Pedidos4.cd84248c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancPedidos/Pedidos4.png
// module id = 1783
// module chunks = 0